<template>
  <div no-body class="my-1 p-1 bg-white">
    <div header-tag="header" class="p-1" role="tab">
      <b-button
        v-b-toggle.accordion-1
        block
        class="d-flex collapseSubHeader"
        @click="isVisibleAvmProperty = !isVisibleAvmProperty"
      >
        <p class="text-dark font-weight-bolder mb-0">AVM Property Information</p>
        <strong class="ml-auto"
          ><i :class="`fa fa-angle-${isVisibleAvmProperty ? 'up' : 'down'} text-dark`"></i
        ></strong>
      </b-button>
    </div>
    <b-collapse id="accordion-1" visible>
      <div class="px-3 m-2 baseContentFont border">
        <b-row class="">
          <b-col class="p-1 textSpacing"
            ><b>County: </b>{{ formatDisplay(Info.county) }}</b-col
          >
          <b-col class=" p-1"
            ><b>Property Type: </b>{{ formatDisplay(Info.type) }}</b-col
          >
          <b-col class=" p-1"
            > <b>Beds: </b>{{ formatDisplay(Info.bedRooms) }}</b-col
          >


        </b-row>
        <b-row>
          <b-col class=" p-1"
            ><b>Baths: </b>{{ formatDisplay(Info.bathRooms) }}</b-col
          >
          <b-col class=" p-1"
            ><b>SqFt: </b>{{ formatDisplay(Info.totalLivingArea) }}</b-col
          >
          <b-col class=" p-1"
            ><b>Land: </b>{{ formatDisplay(Info.landArea) }}</b-col
          >



        </b-row>
        <b-row>
          <b-col class=" p-1"
            ><b>Year Built: </b>{{ formatDisplay(Info.yearBuilt) }}</b-col
          >
          <b-col class=" p-1"
            ><b>Carrier Route: </b>{{ formatDisplay(Info.carrierRoute) }}</b-col
          >
          <b-col class=" p-1 textSpacing"
            ><b>Assessed Value: </b
            >{{ formatDisplay(Info.assessedValue) }}</b-col
          >

        </b-row>
        <b-row>
          <b-col class=" p-1 textSpacing"
            ><b>Assessed Year: </b>{{ formatDisplay(Info.assessedYear) }}</b-col
          >
          <b-col class=" p-1"
            ><b>Sold Price: </b>{{ formatDisplay(Info.soldPrice) }}</b-col
          >
          <b-col class=" p-1"
            ><b>Sold Date: </b>{{ formatDisplay(Info.soldDate) }}</b-col
          >

          </b-row>
          <b-row>
            <b-col class=" p-1"
            ><b>List Price: </b>{{ formatDisplay(Info.listPrice) }}</b-col
          >
          <b-col class=" p-1"
            ><b>List Date: </b>{{ formatDisplay(Info.listDate) }}</b-col
          >
          <b-col class=" p-1"
            ><b>Off Market Date: </b>{{ formatDisplay(Info.offMktDate) }}</b-col
          >
        </b-row>
      </div>
    </b-collapse>
    <!-- AVM Subject valuation -->
    <div header-tag="header" class="p-1 my-1" role="tab">
      <b-button
        v-b-toggle.accordion-2
        block
        class="d-flex collapseSubHeader"
        @click="isVisibleAvmValuation = !isVisibleAvmValuation"
      >
        <p class="text-dark font-weight-bolder mb-0">AVM Subject Valuation</p>
        <strong class="ml-auto"
          ><i
            :class="`fa fa-angle-${isVisibleAvmValuation ? 'up' : 'down'} text-dark`"
          ></i
        ></strong>
      </b-button>
    </div>
    <b-collapse id="accordion-2" visible>
      <div>
        <b-row class="mx-2 my-1">
          <BaseELabel :label="`Property Address: ${PropertyAddress}`" />
          <BaseELabel class="ml-2" :label="avmCoordinates" />
        </b-row>
        <div class="mx-1 ">
          <b-table
            responsive
            striped
            bordered
            :fields="subjectEvaluationfields"
            :items="subjectEvaluationItems"
            :class="{ 
              'mb-0': !subjectEvaluationItems.length, 
              'fraudReportHeaderTable': true, 
            }"
          >
          </b-table>
          <NoRecordFound
            v-if="!subjectEvaluationItems.length"
          ></NoRecordFound>
        </div>
      </div>
    </b-collapse>
    <!-- AVM Transaction History -->

    <div header-tag="header" class="p-1 my-1" role="tab">
      <b-button
        v-b-toggle.accordion-3
        block
        class="d-flex collapseSubHeader"
        @click="
          isVisibleAvmTransactionHistory = !isVisibleAvmTransactionHistory
          "
      >
        <p class="text-dark font-weight-bolder mb-0">AVM Property Transaction History</p>
        <strong
          v-if="isVisibleAvmTransactionHistory"
          aria-hidden="true"
          class="ml-auto"
          ><i class="fa fa-angle-up text-dark"></i
        ></strong>
        <strong v-else class="ml-auto"><i class="fa fa-angle-down text-dark"></i></strong>
      </b-button>
    </div>
    <b-collapse id="accordion-3" visible>
      <div>
        <div class="mx-1 my-3">
          <b-table
            responsive
            striped
            bordered
            :fields="transactionHistoryfields"
            :items="transactionHistoryItems"
            :class="{ 
              'mb-0': !transactionHistoryItems.length, 
              'fraudReportHeaderTable': true, 
            }"
          >
            <template v-slot:cell(buyer)="rowitem">
              <div>
                <div v-if="rowitem.item.buyer.length">
                  <div v-for="(data, index) in rowitem.item.buyer" :key="index">
                    {{ data }}
                  </div></div
                >
                <!-- <div v-else>No Data</div> -->
              </div>
            </template>
            <template v-slot:cell(seller)="rowitem">
              <div>
                <div v-if="rowitem.item.buyer.length">
                  <div
                    v-for="(data, index) in rowitem.item.seller"
                    :key="index"
                  >
                    {{ data }}
                  </div></div
                >
                <!-- <div v-else>No Data</div> -->
              </div>
            </template>
          </b-table>
          <NoRecordFound
            v-if="!transactionHistoryItems.length"
          ></NoRecordFound>
        </div>
      </div>
    </b-collapse>

    <!-- AVM Active Listing -->

    <div header-tag="header" role="tab" class="p-1 my-1">
      <b-button
        v-b-toggle.accordion-4
        block
        class="d-flex collapseSubHeader"
        @click="isVisibleAvmActiveListing = !isVisibleAvmActiveListing"
      >
        <p class="text-dark mb-0 font-weight-bolder">AVM Market Analysis - Maps</p>
        <strong
          v-if="isVisibleAvmActiveListing"
          aria-hidden="true"
          class="ml-auto"
          ><i class="fa fa-angle-up text-dark"></i
        ></strong>
        <strong v-else class="ml-auto"><i class="fa fa-angle-down text-dark"></i></strong>
      </b-button>
    </div>
    <b-collapse id="accordion-4" visible>
      <div v-if="avmMap" class="mx-1 text-center">
        <b-img :src="`data:image/png;base64,${avmMap}`" />
      </div>
      <div
        v-else
        class="mx-1 py-1 text-center baseContentFont border"
        >*** No matching map(s) found. ***</div
      >
    </b-collapse>
    <!-- AVM  Recent Sales -->
    <div class="preventBreak">
    <div
      header-tag="header"
      class="p-1 my-1"
      role="tab"
    >
      <b-button
        v-b-toggle.accordion-5
        block
        class="d-flex collapseSubHeader"
        @click="isVisibleAvmSales = !isVisibleAvmSales"
      >
        <p class="mb-0 text-dark font-weight-bolder">AVM Market Analysis</p>
        <strong class="ml-auto"
          ><i :class="`fa fa-angle-${isVisibleAvmSales ? 'up' : 'down'} text-dark`"></i
        ></strong>
      </b-button>
    </div>
    <b-collapse id="accordion-5" visible>
      <div>
        <div class="mx-1 my-3">
          <AvmMarketAnalysisTable
            :items="sampleView"
            :fields="marketAnalysisfields"
          />
          <NoRecordFound v-if="!salesItems.length"></NoRecordFound>
          <div class="float-right py-3 font-weight-bold">
            <b-link
              :class="sampleView.length <= 20 ? 'textMuted fraudReportLink' : 'fraudReportLink'"
              @click="alterTableData('showLess')"
              >View Less</b-link
            >
            <b-link
              :class="sampleView.length === salesItems.length
                ? 'fraudReportLink textMuted pl-5'
                : 'fraudReportLink pl-5'
                "
              @click="alterTableData('showMore')"
              >View More</b-link
            >
          </div>
        </div>
      </div>
    </b-collapse>
    </div>

    <!-- AVM Charts -->
    <div class="preventBreak">
    <div
      header-tag="header"
      role="tab"
      class="p-1 my-1"
    >
      <b-button
        v-b-toggle.accordion-6
        block
        class="d-flex collapseSubHeader"
        @click="isVisibleAvmCharts = !isVisibleAvmCharts"
      >
        <p class="text-dark font-weight-bolder mb-0">AVM Charts</p>
        <strong class="ml-auto"
          ><i :class="`fa fa-angle-${isVisibleAvmCharts ? 'up' : 'down'} text-dark`"></i
        ></strong>
      </b-button>
    </div>
    <b-collapse id="accordion-6" visible>
      <b-row v-if="chartItems.length" class="text-center">
      <b-col v-for="chart in chartItems" :key="chart.name" class="my-3 col-md-6">
        <b-img
          v-if="chart.image"
          :src="`data:image/png;base64,${chart.image.imageContent}`"
        />
      </b-col>
      </b-row>
      <div v-else class="border mx-1 text-center py-1 baseContentFont">
        *** No matching chart(s) found. ***
      </div>
    </b-collapse>
  </div>
  </div>
</template>

<script>
import NoRecordFound from '@/src/components/_norecord-found.vue'
import format from 'date-fns/format'
import AvmMarketAnalysisTable from './avmMarketAnalysisTable.vue'
export default {
  components: {
    NoRecordFound,
    AvmMarketAnalysisTable,
  },
  props: {
    avmResponse: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      response: '',
      avmCoordinates: '',
      PropertyAddress: '',
      isVisibleAvmProperty: false,
      isVisibleAvmValuation: false,
      isVisibleAvmTransactionHistory: false,
      isVisibleAvmActiveListing: false,
      isVisibleAvmSales: false,
      isVisibleAvmCharts: false,
      avmSubjectValuationAddress: 'wqe',
      avmSubjectValuationCoordinates: 'weqw',
      Images: {},
      subjectEvaluationfields: [
        {
          key: 'estimated',
          label: 'Estimated Value',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'low',
          label: 'Low Value',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'high',
          label: 'High Value',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'confidenceScore',
          label: 'Confidence Score',
          class: 'text-right',
          thStyle: { textAlign: 'right' },
        },
        {
          key: 'forecastStdDeviation',
          label: 'Forecasted Standard Deviation (FSD)',
          class: 'text-right',
          thStyle: { textAlign: 'right' },
        },
      ],
      subjectEvaluationItems: [],
      transactionHistoryfields: [
        {
          key: 'date',
          label: 'Date',
          class: 'text-right',
          thStyle: { textAlign: 'right' },
        },
        {
          key: 'amount',
          label: 'Price',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'type',
          label: 'Type',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'datasource',
          label: 'Data Source',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'buyer',
          label: 'Buyer',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
        {
          key: 'seller',
          label: 'Seller',
          class: 'text-left',
          thStyle: { textAlign: 'left' },
        },
      ],
      transactionHistoryItems: [],
      Info: {},
      marketAnalysisfields: [
        { key: 'slno', label: '#', class: 'text-right' },
        { key: 'dist', label: 'Dist (Miles)', class: 'text-right' },
        { key: 'address', label: 'Address', tdClass: 'textTruncatee' },
        { key: 'zip', label: 'Zip', class:'text-right' },
        { key: 'beds', label: 'Beds ', class: 'text-right' },
        // { key: 'baths', label: 'Baths',tdClass: 'textTruncatee',thStyle: { width: '50px' }},
        { key: 'living', label: 'Living', class: 'text-right' },
        // { key: 'land', label: 'Land',
        { key: 'yearbuilt', label: 'Year Built', class: 'text-right' },
        { key: 'sold', label: 'Sold' },
        // { key: 'solddate', label: 'Sold Date',tdClass: 'textTruncatee'},
        { key: 'list', label: 'List' },
        // { key: 'listdate', label: 'List Date',tdClass: 'textTruncatee'},
        { key: 'type', label: 'Type' },
        { key: 'reo', label: 'REO' },
        // { key: 'foreclosure', label: 'Foreclosure Code'},
        // { key: 'shortsale', label: 'Short Sale Code'},
        { key: 'source', label: 'Source' },
        // { key: 'status', label: ''},
      ],
      activeListingItems: [],
      salesItems: [],
      chartItems: [],
      sampleView: [],
      avmMap: null,
    }
  },
  computed: {
    avmResponseData() {
      return this.avmResponse
    },
  },
  mounted() {
    this.response = this.avmResponseData
      ? this.avmResponseData.avmResponse
        ? this.avmResponseData.avmResponse.propertyValuationReportResponseEx
          ? this.avmResponseData.avmResponse.propertyValuationReportResponseEx
              .response.report.reportData
          : null
        : null
      : null
    if (this.response) {
      this.getavmPropertyInfo()
      this.getavmSubjectValuation()
      this.getavmTransactionHistory()
      this.getavmListing()
      this.getavmCharts()
    }
  },
  methods: {
    formatPrice(number) {
      if(number === 0) return '$0'
      else return number
        ? '$' + Intl.NumberFormat('en-US').format(number.toFixed(2))
        : null
    },
    formatDate(date) {
      return date ? format(date, 'MM/DD/YYYY') : null
    },
    formatDisplay(value) {
      return value === 0 ? value : value || ''
    },
    getYesOrNo(code) {
      return code === 'Y' ? 'Yes' : code === 'N' ? 'No' : null
    },
    getavmPropertyInfo() {
      let propertyInfo = this.response.property.info || null
      if (propertyInfo !== null) {
        let countyZip =
          propertyInfo.county && this.response.property.address.zip
            ? propertyInfo.county +
              ' (' +
              this.response.property.address.zip +
              ')'
            : null
        this.Info = {
          county: this.formatDisplay(countyZip),
          type: this.formatDisplay(propertyInfo.type),
          bedRooms: this.formatDisplay(propertyInfo.bedRooms),
          bathRooms: this.formatDisplay(propertyInfo.bathRooms),
          totalLivingArea: this.formatDisplay(
            propertyInfo.totalLivingArea.toLocaleString()
          ),
          landArea: this.formatDisplay(propertyInfo.landArea.toLocaleString()),
          yearBuilt: this.formatDisplay(propertyInfo.yearBuilt),
          carrierRoute: this.formatDisplay(propertyInfo.carrierRoute),
          assessedValue: this.formatDisplay(
            this.formatPrice(propertyInfo.assessedValue)
          ),
          assessedYear: this.formatDisplay(propertyInfo.assessedYear),
          soldPrice: this.formatDisplay(
            this.formatPrice(propertyInfo.soldPrice)
          ),
          soldDate: this.formatDisplay(this.formatDate(propertyInfo.soldDate)),
          listPrice: this.formatDisplay(
            this.formatPrice(propertyInfo.listPrice)
          ),
          listDate: this.formatDisplay(this.formatDate(propertyInfo.listDate)),
          offMktDate: this.formatDisplay(
            this.formatDate(propertyInfo.offMktDate)
          ),
        }
      }
    },
    getavmSubjectValuation() {
      let summaryData = this.response.summaryArray ? this.response.summaryArray.summary : [] || []
      this.subjectEvaluationItems = (summaryData || []).map((data) => {
        return {
          estimated: this.formatDisplay(this.formatPrice(data.estimated)),
          low: this.formatDisplay(this.formatPrice(data.low)),
          high: this.formatDisplay(this.formatPrice(data.high)),
          confidenceScore: this.formatDisplay(data.confidenceScore),
          forecastStdDeviation: this.formatDisplay(data.forecastStdDeviation),
        }
      })
      let addressObj = this.response.property
      this.PropertyAddress =
        addressObj.address.fullAddress +
        ', ' +
        addressObj.address.city +
        ', ' +
        addressObj.address.state +
        ' ' +
        addressObj.address.zip

      this.avmCoordinates =
        ' ( Latitude: ' +
        parseFloat(addressObj.info.geoCode.latitude).toFixed(2) +
        ' , Longitude: ' +
        parseFloat(addressObj.info.geoCode.longitude).toFixed(2) +
        ')'
    },
    getavmTransactionHistory() {
      let transactionListData = this.response.property.historicalTransactions
        ? this.response.property.historicalTransactions.transactionArray
          ? this.response.property.historicalTransactions.transactionArray
              .transaction
          : null
        : null
      this.transactionHistoryItems = (transactionListData || []).map((data) => {
        return {
          date: this.formatDisplay(this.formatDate(data.date)),
          amount: this.formatDisplay(this.formatPrice(data.amount)),
          type: this.formatDisplay(data.type),
          datasource: this.formatDisplay(data.datasource),
          buyer: data.ownerInfo ? data.ownerInfo.buyerArray.buyer : [],
          seller: data.ownerInfo ? data.ownerInfo.sellerArray.seller : [],
        }
      })
    },
    getavmCharts() {
      let charts =
        this.response.charts ? this.response.charts.chartGroupArray ?
                               this.response.charts.chartGroupArray.chartGroup[0].chartArray.chart || [] : []
                              : []
      charts.map((data) => {
        this.chartItems.push(data)
      })
      this.avmMap = this.avmResponseData.byteArray || null
    },
    getAddress(address) {
      return (
        this.formatAddress(address.number) +
        this.formatAddress(address.directional) +
        this.formatAddress(address.street) +
        this.formatAddress(address.suffix) +
        this.formatAddress(address.postDirectional) +
        (address.unit ? '#' + address.unit : ' ')
      )
    },
    formatAddress(value) {
      return value ? value + ' ' : ' '
    },
    alterTableData(choice) {
      switch (choice) {
        case 'showMore':
          if (this.sampleView.length < this.salesItems.length) {
            this.sampleView = this.salesItems.slice(
              0,
              this.sampleView.length + 20
            )
          }
          break
        case 'showLess':
          if (this.sampleView.length > 20) {
            if (this.sampleView.length - 20 < 20)
              this.sampleView.splice(20, this.sampleView.length - 20)
            else this.sampleView.splice(-20)
          }
          break
      }
    },
    getavmListing() {
      let activeList =
        this.response.comparables ? this.response.comparables.propertyList ?
                                      this.response.comparables.propertyList.propertyArray ?
                                        this.response.comparables.propertyList.propertyArray.property : []
                                      : []
                                  : [] || []
      activeList.map((dataItem, i) => {
        let data = activeList.find((x) => x.index === i + 1)
        let Object = {
          slno: i+1,
          dist: this.formatDisplay(data.distance),
          address: this.formatDisplay(this.getAddress(data.address)),
          zip: this.formatDisplay(data.address.zip),
          beds: this.formatDisplay(data.info.bedRooms),
          baths: this.formatDisplay(data.info.bathRooms),
          living: this.formatDisplay(data.info.livingArea.toLocaleString()),
          land: this.formatDisplay(data.info.landArea.toLocaleString()),
          yearbuilt: this.formatDisplay(data.info.yearBuilt),
          sold: this.formatDisplay(this.formatPrice(data.info.soldPrice)),
          solddate: this.formatDisplay(this.formatDate(data.info.soldDate)),
          list: this.formatDisplay(this.formatPrice(data.info.listPrice)),
          listdate: this.formatDisplay(this.formatDate(data.info.listDate)),
          type: this.formatDisplay(data.info.type),
          reo: this.formatDisplay(
            this.getYesOrNo(data.info.realEstateOwnedCode)
          ),
          foreclosure: this.formatDisplay(
            this.getYesOrNo(data.info.foreclosureCode)
          ),
          shortsale: this.formatDisplay(data.info.shortSaleCode),
          source: this.formatDisplay(data.source),
          status: this.formatDisplay(data.type),
        }
        this.salesItems.push(Object)
      })
      this.sampleView = this.salesItems.slice(0, 20)
    },
  },
}
</script>

<style lang="scss" module>
/* stylelint-disable selector-max-type */
@import '@design';

.noRecord {
  font-size: $size-content-font;
  border: 1px solid #dee2e6;
}

table>tbody>tr>td {
  letter-spacing: normal;
  letter-spacing: 0.4em;
  letter-spacing: 4px;
  letter-spacing: 0.4px;
}
</style>

<style lang="scss" scoped>
@import 'src/design/_redesign.scss';
.textSpacing {
  letter-spacing: normal;
  letter-spacing: 0.4em;
  letter-spacing: 4px;
  letter-spacing: 0.4px;
}

.textMuted {
  cursor: not-allowed;
  opacity: 0.5;
}

.collapseSubHeader {
  background-color: $color-raisin-40 !important;
  border: none;
}

a.fraudReportLink {
  font-size: 11px;
  line-height: 16px;
  color: $color-dark-purple;
  text-transform: uppercase;
}
</style>
